/* The OAuth permissions the app actually requests, each paired with the single
   step it serves.

   This is the source of truth for the copy on the home page and the security
   page. Google's home-page requirement is that the page "explain with
   transparency the purpose for which your app requests user data", and the
   sensitive-scope review reads the same list again — a reviewer who compares
   the two pages must not find them worded differently, so neither page may
   keep its own copy of this table.

   Keep in step with META_SCOPES / GOOGLE_SCOPES in
   database/supabase/functions/oauth-start/index.ts, which is what is actually
   sent to the authorize endpoint. The prose in pages/Privacy.tsx says the same
   thing in sentence form; that one is the approved legal document and is
   deliberately not generated from here. */

export type Scope = readonly [scope: string, why: string];

export const META_SCOPES: readonly Scope[] = [
  ["pages_show_list", "List the Pages you administer, so you can pick one."],
  ["pages_read_engagement", "Read a Page's name and picture, and obtain its publishing token."],
  ["pages_manage_posts", "Create the photo or video post you composed."],
  ["instagram_basic", "Identify the Instagram Business account linked to your Page."],
  ["instagram_content_publish", "Publish your media to that Instagram account."],
];

export const GOOGLE_SCOPES: readonly Scope[] = [
  ["youtube.upload", "Upload the video you composed to the channel you chose."],
  ["youtube.readonly", "List your channels and read their title and thumbnail."],
];
